import { SkeletonProps } from '@mui/material';

import { Container } from './styles';

export default function Skeleton(props: SkeletonProps) {
    return <Container variant="rectangular" {...props} />;
}
